module.exports = __webpack_public_path__ + "static/media/heroSpoonHero.80846565.jpg";